import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AmazonItemSearch } from 'src/app/models/amazon-item-search';
import { EbayBrowseItemSummery } from 'src/app/models/ebay';
import { AmazonService } from 'src/app/services/amazon.service';
import { EbayService } from 'src/app/services/ebay.service';
import { LoadingService } from 'src/app/utils/services/loading.service';

@Component({
    selector: 'app-product-screen',
    templateUrl: './product-screen.component.html',
    styleUrls: ['./product-screen.component.css'],
    standalone: false
})
export class ProductScreenComponent implements OnInit{

  search: string;
  amazonItems: AmazonItemSearch;
  ebayBrowseItems: EbayBrowseItemSummery;

  constructor(private route: ActivatedRoute,
      private router: Router,
      private amazonService: AmazonService,
      private ebayService: EbayService,
      private loadingService: LoadingService,
  ) {

   }
   checkPrice(item: AmazonItemSearch){
    this.ebayService.storeEbayData(this.ebayBrowseItems);
    let asin: string = item?.items[0]?.asin === undefined ? '' : item.items[0].asin;
    this.router.navigate(['/pricing'], { queryParams: { asin: asin } });
   }

   private async searchProduct(searchType: string, search: string){
    //this.ebayService.searchEbayProduct();
   }

   async ngOnInit(): Promise<void> {
    this.loadingService.showLoading();

    this.route.queryParams.subscribe((params) => {
      let queryParams = {};
      for (let key in params) {
        queryParams[key] = params[key];
      };
      let search: string = queryParams['search'];
      let searchType: string = queryParams['search_type'];

      this.search = search;      
    
      this.ebayService.ebayBrowseSearch(searchType, search, 'New', 10, 0).then((response) => {
        this.ebayBrowseItems = response;
        
      })
      .catch(err =>{
        this.search = 'error: ' + 'fetching data';//(err.message || 'Unknown error');
      })
      .finally(() =>{
        this.loadingService.hideLoading();
      });
    
      this.amazonService.getSapiItemListResult(searchType, search).then((response) => {
        this.amazonItems = response;
      }
      )
      .catch(err =>{
        this.search = 'error: ' + 'fetching data';//(err.message || 'Unknown error');
      })
      .finally(() =>{
        this.loadingService.hideLoading();
      });
      
      ;
    });
    
   }
}
